import { RiFacebookFill, RiInstagramLine, RiPinterestLine, RiTwitterFill, RiYoutubeLine } from "react-icons/ri";




export const blurIconsData = [
    {
        id:1,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-usa-today.png`
    },
    {
        id:2,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-abc-news.svg`
    },
    {
        id:3,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-fox.svg`
    },
    {
        id:4,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-times.svg`
    },
    {
        id:5,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-consumer-reports.svg`
    },
    {
        id:6,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-wsj.svg`
    },
    {
        id:7,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-chicago-tribune.svg`
    }
]


export const broadIconsData = [
    {
        id:1,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-garmin.png`
    },
    {
        id:2,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-app-health.png`
    },
    {
        id:3,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-samsung-health.png`
    },
    {
        id:4,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-apple-watch.png`

    },
    {
        id:5,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-fitbit.png`
    },
    {
        id:6,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-withings.png?v07092020`
    },
    {
        id:7,
        icon: `https://s3.amazonaws.com/img.mynetdiary.com/images/logo-google-fit.png`
    }
]




export const mediaIconsData = [
    {
      id: 1,
      icons: <RiInstagramLine />,
      colors: "#ff0081",
      links: "."
    },
    {
      id: 2,
      icons: <RiFacebookFill />,
      colors: "#1d50bd",
      links: "."
    },
    {
      id: 3,
      icons: <RiTwitterFill />,
      colors: "#00c4ff",
      links: "."
    },
    {
      id: 4,
      icons: <RiYoutubeLine />,
      colors: "red",
      links: "."
    },
    {
      id: 5,
      icons: <RiPinterestLine />,
      colors: "#a90800",
      links: "."
    }
]